import { tKey } from 'ember-intl';
import type { SupportedCurrencies } from 'frontend-utils/utils/constants/currency-mapping-constants';

export const CURRENCY_TRANSLATION_MAPPING: Record<SupportedCurrencies, string> =
  {
    AED: tKey('general.currency.AED'),
    AFN: tKey('general.currency.AFN'),
    ALL: tKey('general.currency.ALL'),
    AMD: tKey('general.currency.AMD'),
    ANG: tKey('general.currency.ANG'),
    AOA: tKey('general.currency.AOA'),
    ARS: tKey('general.currency.ARS'),
    AUD: tKey('general.currency.AUD'),
    AWG: tKey('general.currency.AWG'),
    AZN: tKey('general.currency.AZN'),
    BAM: tKey('general.currency.BAM'),
    BBD: tKey('general.currency.BBD'),
    BDT: tKey('general.currency.BDT'),
    BGN: tKey('general.currency.BGN'),
    BHD: tKey('general.currency.BHD'),
    BIF: tKey('general.currency.BIF'),
    BMD: tKey('general.currency.BMD'),
    BND: tKey('general.currency.BND'),
    BOB: tKey('general.currency.BOB'),
    BRL: tKey('general.currency.BRL'),
    BSD: tKey('general.currency.BSD'),
    BTN: tKey('general.currency.BTN'),
    BWP: tKey('general.currency.BWP'),
    BYN: tKey('general.currency.BYN'),
    BYR: tKey('general.currency.BYR'),
    BZD: tKey('general.currency.BZD'),
    CAD: tKey('general.currency.CAD'),
    CDF: tKey('general.currency.CDF'),
    CHF: tKey('general.currency.CHF'),
    CLF: tKey('general.currency.CLF'),
    CLP: tKey('general.currency.CLP'),
    CNY: tKey('general.currency.CNY'),
    COP: tKey('general.currency.COP'),
    CRC: tKey('general.currency.CRC'),
    CUP: tKey('general.currency.CUP'),
    CVE: tKey('general.currency.CVE'),
    CYP: tKey('general.currency.CYP'),
    CZK: tKey('general.currency.CZK'),
    DJF: tKey('general.currency.DJF'),
    DKK: tKey('general.currency.DKK'),
    DOP: tKey('general.currency.DOP'),
    DZD: tKey('general.currency.DZD'),
    EGP: tKey('general.currency.EGP'),
    ERN: tKey('general.currency.ERN'),
    ETB: tKey('general.currency.ETB'),
    EUR: tKey('general.currency.EUR'),
    FJD: tKey('general.currency.FJD'),
    FKP: tKey('general.currency.FKP'),
    GBP: tKey('general.currency.GBP'),
    GEL: tKey('general.currency.GEL'),
    GHS: tKey('general.currency.GHS'),
    GIP: tKey('general.currency.GIP'),
    GMD: tKey('general.currency.GMD'),
    GNF: tKey('general.currency.GNF'),
    GTQ: tKey('general.currency.GTQ'),
    GYD: tKey('general.currency.GYD'),
    HKD: tKey('general.currency.HKD'),
    HNL: tKey('general.currency.HNL'),
    HRK: tKey('general.currency.HRK'),
    HTG: tKey('general.currency.HTG'),
    HUF: tKey('general.currency.HUF'),
    IDR: tKey('general.currency.IDR'),
    ILS: tKey('general.currency.ILS'),
    INR: tKey('general.currency.INR'),
    IQD: tKey('general.currency.IQD'),
    IRR: tKey('general.currency.IRR'),
    ISK: tKey('general.currency.ISK'),
    JMD: tKey('general.currency.JMD'),
    JOD: tKey('general.currency.JOD'),
    JPY: tKey('general.currency.JPY'),
    KES: tKey('general.currency.KES'),
    KGS: tKey('general.currency.KGS'),
    KHR: tKey('general.currency.KHR'),
    KMF: tKey('general.currency.KMF'),
    KPW: tKey('general.currency.KPW'),
    KRW: tKey('general.currency.KRW'),
    KWD: tKey('general.currency.KWD'),
    KYD: tKey('general.currency.KYD'),
    KZT: tKey('general.currency.KZT'),
    LAK: tKey('general.currency.LAK'),
    LBP: tKey('general.currency.LBP'),
    LKR: tKey('general.currency.LKR'),
    LRD: tKey('general.currency.LRD'),
    LSL: tKey('general.currency.LSL'),
    LTL: tKey('general.currency.LTL'),
    LVL: tKey('general.currency.LVL'),
    LYD: tKey('general.currency.LYD'),
    MAD: tKey('general.currency.MAD'),
    MDL: tKey('general.currency.MDL'),
    MGA: tKey('general.currency.MGA'),
    MKD: tKey('general.currency.MKD'),
    MMK: tKey('general.currency.MMK'),
    MNT: tKey('general.currency.MNT'),
    MOP: tKey('general.currency.MOP'),
    MRO: tKey('general.currency.MRO'),
    MRU: tKey('general.currency.MRU'),
    MUR: tKey('general.currency.MUR'),
    MVR: tKey('general.currency.MVR'),
    MWK: tKey('general.currency.MWK'),
    MXN: tKey('general.currency.MXN'),
    MXV: tKey('general.currency.MXV'),
    MYR: tKey('general.currency.MYR'),
    MZN: tKey('general.currency.MZN'),
    NAD: tKey('general.currency.NAD'),
    NGN: tKey('general.currency.NGN'),
    NIO: tKey('general.currency.NIO'),
    NOK: tKey('general.currency.NOK'),
    NPR: tKey('general.currency.NPR'),
    NZD: tKey('general.currency.NZD'),
    OMR: tKey('general.currency.OMR'),
    PAB: tKey('general.currency.PAB'),
    PEN: tKey('general.currency.PEN'),
    PGK: tKey('general.currency.PGK'),
    PHP: tKey('general.currency.PHP'),
    PKR: tKey('general.currency.PKR'),
    PLN: tKey('general.currency.PLN'),
    PYG: tKey('general.currency.PYG'),
    QAR: tKey('general.currency.QAR'),
    RON: tKey('general.currency.RON'),
    RSD: tKey('general.currency.RSD'),
    RUB: tKey('general.currency.RUB'),
    RWF: tKey('general.currency.RWF'),
    SAR: tKey('general.currency.SAR'),
    SBD: tKey('general.currency.SBD'),
    SCR: tKey('general.currency.SCR'),
    SDG: tKey('general.currency.SDG'),
    SEK: tKey('general.currency.SEK'),
    SGD: tKey('general.currency.SGD'),
    SHP: tKey('general.currency.SHP'),
    SLE: tKey('general.currency.SLE'),
    SLL: tKey('general.currency.SLL'),
    SOS: tKey('general.currency.SOS'),
    SRD: tKey('general.currency.SRD'),
    SSP: tKey('general.currency.SSP'),
    STD: tKey('general.currency.STD'),
    STN: tKey('general.currency.STN'),
    SVC: tKey('general.currency.SVC'),
    SYP: tKey('general.currency.SYP'),
    SZL: tKey('general.currency.SZL'),
    THB: tKey('general.currency.THB'),
    TJS: tKey('general.currency.TJS'),
    TMT: tKey('general.currency.TMT'),
    TND: tKey('general.currency.TND'),
    TOP: tKey('general.currency.TOP'),
    TRY: tKey('general.currency.TRY'),
    TTD: tKey('general.currency.TTD'),
    TWD: tKey('general.currency.TWD'),
    TZS: tKey('general.currency.TZS'),
    UAH: tKey('general.currency.UAH'),
    UGX: tKey('general.currency.UGX'),
    USD: tKey('general.currency.USD'),
    UYU: tKey('general.currency.UYU'),
    UZS: tKey('general.currency.UZS'),
    VES: tKey('general.currency.VES'),
    VND: tKey('general.currency.VND'),
    VUV: tKey('general.currency.VUV'),
    WST: tKey('general.currency.WST'),
    XAF: tKey('general.currency.XAF'),
    XAG: tKey('general.currency.XAG'),
    XAU: tKey('general.currency.XAU'),
    XCD: tKey('general.currency.XCD'),
    XCG: tKey('general.currency.XCG'),
    XDR: tKey('general.currency.XDR'),
    XOF: tKey('general.currency.XOF'),
    XPD: tKey('general.currency.XPD'),
    XPF: tKey('general.currency.XPF'),
    XPT: tKey('general.currency.XPT'),
    YER: tKey('general.currency.YER'),
    ZAR: tKey('general.currency.ZAR'),
    ZMW: tKey('general.currency.ZMW'),
    ZWL: tKey('general.currency.ZWL'),
  };
